function importAll(r) {
    return r.keys().map(r);
  }
  
  const Spain_L = importAll(require.context('../assets/photos/Spain_L', false, /\.(png|jpe?g|svg)$/));
    
  export default Spain_L;